module.exports = __webpack_public_path__ + "img/k_diamond.e564cf9a.jpg";